import React from 'react'
import { motion, AnimatePresence } from "framer-motion"


const Info = ({ showAllergens, allergens, handleShowAllergensClick }) => {
   

    return (
        <AnimatePresence>
        <motion.div
            
                    initial={{y:-300, opacity: 0}}
                    animate={{ y:0, opacity:1}}
                    exit={{y:-300, opacity:0}}
                    transition={{ delay: 0.01 }}
        

           

            className={showAllergens && `flex flex-row font-mono h-[1350px]    bg-backgroundOne items-center  text-mainTwo` }>
            {showAllergens &&
                <>
                    <div className='flex flex-col  text-center text-sm w-12/12 ml-2'>
                        <p>
                            {allergens}

                        </p>
                        <div className='text-sm mt-4 p-1 m-1 w-1/2 m-auto cursor-pointer align-self-center text-red border-2 border-b-red rounded-md'
                        onClick={() => handleShowAllergensClick()}
                    > <p className='p-1'>Скрий Алергените!</p>
                    </div>
                    </div>
                </>}
        </motion.div>
        </AnimatePresence>
    )
}

export default Info